import { render, staticRenderFns } from "./CmsImageLink.vue?vue&type=template&id=580db849&scoped=true&"
import script from "./CmsImageLink.vue?vue&type=script&lang=ts&"
export * from "./CmsImageLink.vue?vue&type=script&lang=ts&"
import style0 from "./CmsImageLink.vue?vue&type=style&index=0&id=580db849&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580db849",
  null
  
)

export default component.exports